import React, { Component } from "react";
import { connect } from "react-redux";
import Table, { tableActions } from '@mawesi-sas/mws_react_component_table';
import FontAwesome from "react-fontawesome";

import { showHideModalCreateTipoProducto } from "../actions";

const { mswTable_mostrarDatos } = tableActions;

class TiposProducto extends Component {
  componentDidMount() {
    // if (
    // 	this.props.modalCreate.getIn(`data.tipos_producto`.split(".")) &&
    // 	this.props.modalCreate
    // 		.getIn(`data.tipos_producto`.split("."))
    // 		.count()
    // ) {
    const tiposProducto = this.props.modalCreate
      .getIn(`data.tipos_producto`.split("."))
      .toJS()
      .map(x => {
        x._enabled = true;
        return x;
      });

    this.props.mswTable_mostrarDatos(
      "tiposervicios",
      "modalCreate.data.tables.tipos_producto",
      tiposProducto,
      1,
      tiposProducto.length
    );
    // }
  }

  render() {
    return (
      <React.Fragment>
        <Table
          reducer="tiposervicios"
          table={`modalCreate.data.tables.tipos_producto`}
          showResumeFooter={false}
          columns={[
            {
              ID: 0,
              CAPTION: "",
              VALUE: "selected",
              TYPE: "selection",
              INPUT: "checkbox",
              WIDTH: 24,
              FIXED: true
            },
            {
              ID: 1,
              CAPTION: "Nombre",
              TYPE: "custom",
              WIDTH: 160,
              RENDER_ROW: reg => {
                return (
                  <span
                    style={{
                      color: "#4f9fcf",
                      cursor: "pointer"
                    }}
                    onClick={e =>
                      this.props.showHideModalCreateTipoProducto(
                        true,
                        reg.get("id3n71f13r")
                      )
                    }
                  >
                    {reg.getIn("nombre".split("."))}
                  </span>
                );
              }
            },
            {
              ID: 2,
              CAPTION: "Descripción",
              VALUE: "descripcion",
              TYPE: "text",
              WIDTH: 320
            },
            {
              ID: 3,
              CAPTION: "Valor máximo",
              VALUE: "valor_maximo",
              TYPE: "number",
              FORMAT: "$0,0.00"
            },
            {
              ID: 4,
              CAPTION: "Valor fijo",
              WIDTH: 80,
              TYPE: "custom",
              RENDER_ROW: reg => (
                <div
                  style={{
                    textAlign: "center"
                  }}
                >
                  {" "}
                  <FontAwesome
                    name={`${
                      Number(reg.get("valor_fijo")) ? "check-" : ""
                    }square`}
                  />
                </div>
              )
            },
            {
              ID: 5,
              CAPTION: "Usuarios",
              WIDTH: 500,
              TYPE: "custom",
              RENDER_ROW: reg => {
                return reg.get("users").map(x => (
                  <span
                    key={`usr[${x.get("id")}]`}
                    title={x.get("name")}
                    className="label label-default"
                  >
                    {" "}
                    {x.get("username")}{" "}
                  </span>
                ));
              }
            }
          ]}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    modalCreate: state.tiposervicios.get("modalCreate"),
    elementos: state.layout.get("elementos")
  };
}

const mapDispatchToProps = {
  mswTable_mostrarDatos,
  showHideModalCreateTipoProducto
};

export default connect(mapStateToProps, mapDispatchToProps)(TiposProducto);
